var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.25L10 16.25L13 13.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5V16.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6599 14.0674C17.3119 13.6089 17.8009 12.9546 18.0559 12.1993C18.3108 11.4441 18.3184 10.6272 18.0777 9.86732C17.8369 9.10742 17.3603 8.44402 16.7169 7.97337C16.0736 7.50272 15.297 7.24933 14.4999 7.24995H13.5549C13.3293 6.37085 12.9073 5.55439 12.3205 4.86201C11.7337 4.16963 10.9975 3.61939 10.1673 3.25271C9.33709 2.88604 8.43452 2.71247 7.52753 2.74509C6.62055 2.7777 5.73277 3.01565 4.93105 3.44102C4.12933 3.86639 3.43456 4.46809 2.89903 5.20082C2.3635 5.93356 2.00118 6.77823 1.83933 7.67126C1.67749 8.56429 1.72035 9.4824 1.96467 10.3565C2.209 11.2305 2.64843 12.0378 3.24989 12.7174",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a1677596b8237e03e5477eb052851768.svg";
export { ForwardRef as ReactComponent };